<template>
  <div class="d-flex justify-content-between align-items-center flex-wrap py-2" v-if="lastPage > 0">
    <p class="text-secondary text-xs mb-0" v-if="total !== null">
      Menampilkan {{ from }}-{{ to }} dari {{ total }} data
    </p>
    <ul class="pagination pagination-sm mb-0 ms-auto">
      <li class="page-item" :class="{ disabled: currentPage <= 1 }">
        <a class="page-link" href="javascript:;" @click="go(currentPage - 1)">
          <i class="fa fa-angle-left"></i>
        </a>
      </li>
      <li
        class="page-item"
        v-for="(page, i) in pages"
        :key="i"
        :class="{ active: page === currentPage, disabled: page === '...' }"
      >
        <a class="page-link" href="javascript:;" @click="page !== '...' && go(page)">{{ page }}</a>
      </li>
      <li class="page-item" :class="{ disabled: currentPage >= lastPage }">
        <a class="page-link" href="javascript:;" @click="go(currentPage + 1)">
          <i class="fa fa-angle-right"></i>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "pagination",
  props: {
    currentPage: {
      type: Number,
      default: 1,
    },
    lastPage: {
      type: Number,
      default: 1,
    },
    total: {
      type: Number,
      default: null,
    },
    perPage: {
      type: Number,
      default: 10,
    },
  },
  emits: ["change"],
  computed: {
    from() {
      if (!this.total) return 0;
      return (this.currentPage - 1) * this.perPage + 1;
    },
    to() {
      if (!this.total) return 0;
      return Math.min(this.currentPage * this.perPage, this.total);
    },
    pages() {
      const last  = this.lastPage;
      const curr  = this.currentPage;
      const delta = 1;
      const range = [];

      for (let i = 1; i <= last; i++) {
        if (i === 1 || i === last || (i >= curr - delta && i <= curr + delta)) {
          range.push(i);
        }
      }

      const withDots = [];
      let prev = null;
      range.forEach((i) => {
        if (prev !== null && i - prev > 1) {
          withDots.push("...");
        }
        withDots.push(i);
        prev = i;
      });

      return withDots;
    },
  },
  methods: {
    go(page) {
      if (page < 1 || page > this.lastPage || page === this.currentPage) return;
      this.$emit("change", page);
    },
  },
};
</script>
